import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { AppSettings } from './settings/appSettings';
import dayjs from 'dayjs';
import { EventHelper } from './helpers/eventHelper';
import { DomainType } from './store/enums';
import enTranslation from './locales/en_translation.json';
import ruTranslation from './locales/ru_translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      fallbackLng: 'en',
      preload: ['en', 'ru'],
      ns: ['translation'],
      defaultNS: 'translation',
      supportedLngs: ['en', 'ru'],
      debug: AppSettings.IS_DEV,
      resources: {
        en: {
          translation: enTranslation,
        },
        ru: {
          translation: ruTranslation,
        },
      },
      react: {
        useSuspense: true,
      },
    },
    (err) => {
      if (err && AppSettings.IS_DEV) {
        return console.error(err);
      }
    }
  );

const isDomainRu = EventHelper.getDomainType(window.location.host) === DomainType.Ru;
if (isDomainRu) {
  i18n.changeLanguage('ru');
  dayjs.locale('ru');
} else {
  i18n.changeLanguage('en');
  dayjs.locale('en');
}

export default i18n;
